import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { PendingOrder } from '../pending-order';
import { PendingOrderTypesBuilder } from './pending-order-type.builder';
import { ToolCategoryBuilder } from './tool-category.builder';

export class PendingOrderBuilder {
  static fromJson(json) {
    return (json)
      ? new PendingOrder(
        json.name,
        json.reference,
        json.isHolder,
        parseNumber(json.stock),
        parseNumber(json.orderQuantity),
        parseNumber(json.validationQuantity),
        PendingOrderTypesBuilder.fromJson(json.pendingOrderType),
        ToolCategoryBuilder.fromJson(json.toolCategory),
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ?
      sortByNumber('date', mapCollection(PendingOrderBuilder.fromJson, list)) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/pending-order.builder.ts